// Named days, never "tomorrow". Short day and month, no year unless it matters.
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const LONG = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const parts = (iso: string) => iso.slice(0, 10).split("-").map(Number) as [number, number, number];
export const dow = (iso: string) => { const [y, m, d] = parts(iso); return new Date(Date.UTC(y, m - 1, d)).getUTCDay(); };
export const dayShort = (iso: string) => DAYS[dow(iso)];
export const dayLong = (iso: string) => LONG[dow(iso)];
export const dayNum = (iso: string) => parts(iso)[2];
export const dateLabel = (iso: string) => { const [, m, d] = parts(iso); return `${DAYS[dow(iso)]} ${d} ${MONTHS[m - 1]}`; };
export const shortDate = (iso: string) => { const [, m, d] = parts(iso); return `${d} ${MONTHS[m - 1]}`; };

export function addDays(iso: string, n: number): string {
  const [y, m, d] = parts(iso);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}
export function mondayOf(iso: string): string {
  const k = dow(iso);
  return addDays(iso, k === 0 ? -6 : 1 - k);
}
export function todayIso(now = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/London", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
}
export const daysBetween = (a: string, b: string) => {
  const [y1, m1, d1] = parts(a); const [y2, m2, d2] = parts(b);
  return Math.round((Date.UTC(y2, m2 - 1, d2) - Date.UTC(y1, m1 - 1, d1)) / 86400000);
};

/** Whole weeks from today to a date: the one count every screen shows (32 weeks and 2 days reads 32). */
export const weeksTo = (today: string, date: string) => Math.max(0, Math.floor(daysBetween(today, date) / 7));
